import { isHttpClientError } from "../../../lib/http/errors";
import type { HotelMapBounds, HotelMapPoi, HotelMapViewport } from "../types";

/** 判断点位是否为房资源酒店，并兼容旧高德住宿分类测试数据。 */
export function isLodgingPoi(item: HotelMapPoi): boolean {
  const typecode = item.typecode.trim();
  return typecode === "resource_stay" || typecode.startsWith("100");
}

/** 使用原始矩形和缩放级别组合酒店地图视口。 */
export function toViewport(bounds: HotelMapBounds, zoom: number): HotelMapViewport {
  return { ...bounds, zoom };
}

/** 将酒店地图统一 HTTP 业务错误映射为用户提示。 */
export function hotelMapErrorMessage(error: unknown): string {
  const code = isHttpClientError(error) ? error.code : null;
  switch (code) {
    case "HOTEL_MAP_SCOPE_TOO_LARGE":
      return "范围过大，请放大地图";
    case "HOTEL_MAP_UPSTREAM_UNAVAILABLE":
      return "房资源酒店暂时无法加载，请稍后重试";
    case "HOTEL_MAP_INVALID_BOUNDS":
      return "地图范围无效，请重试";
    default:
      return "酒店加载失败，请重试";
  }
}
